/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPPROPOSALPROGRESS = {
    InProgress: '1',
    Complete: '2'
} as const;
export type IAPPROPOSALPROGRESS = typeof IAPPROPOSALPROGRESS[keyof typeof IAPPROPOSALPROGRESS];


export function IAPPROPOSALPROGRESSFromJSON(json: any): IAPPROPOSALPROGRESS {
    return IAPPROPOSALPROGRESSFromJSONTyped(json, false);
}

export function IAPPROPOSALPROGRESSFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPPROPOSALPROGRESS {
    return json as IAPPROPOSALPROGRESS;
}

export function IAPPROPOSALPROGRESSToJSON(value?: IAPPROPOSALPROGRESS | null): any {
    return value as any;
}

